var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39817 7.7967C6.70726 7.7967 7.7685 6.73546 7.7685 5.42636C7.7685 4.11726 6.70726 3.05603 5.39817 3.05603C4.08907 3.05603 3.02783 4.11726 3.02783 5.42636C3.02783 6.73546 4.08907 7.7967 5.39817 7.7967Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0069 9.59294V22.7435H14.0899V16.2403C14.0899 14.5243 14.4128 12.8624 16.5404 12.8624C18.6389 12.8624 18.6649 14.8244 18.6649 16.3486V22.7446H22.7501V15.5329C22.7501 11.9904 21.9874 9.26794 17.8469 9.26794C15.859 9.26794 14.5265 10.3589 13.9816 11.3913H13.9264V9.59294H10.0069ZM3.35303 9.59294H7.44261V22.7435H3.35303V9.59294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.12da62086997cbea518f49506fc446ce.svg";
export { ForwardRef as ReactComponent };